import AmountFormat from '~components/i18n/amount-format';
import { Mode, Tier } from '~services/business/pricing';
import { getMonthlyTurnoverLimit } from '~services/business/pricing/get-price-amount';
import { Currency } from '~services/i18n/currency';
import { Trans } from '@lingui/macro';
import { PricingPlanComponentsProps } from '~components/pricing/types';

type TurnoverLimitProps = PricingPlanComponentsProps;

export const MonthlyTurnoverLimit = ({
    currency,
    language,
    tier,
}: TurnoverLimitProps) => {
    return (
        <>
            <AmountFormat
                noSign
                textColor="inherit"
                amount={getMonthlyTurnoverLimit(tier, Mode.MONTHLY, currency)}
                currencyEnum={currency}
                language={language}
            />
            <Trans id="global.pricing.month" />
        </>
    );
};
